import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { OrganisationService } from '@src/core/services';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LoyaltyProgramListProduct } from '../../models';

@Component({
  selector: 'lp-product-list-card',
  templateUrl: './product-list-card.component.html',
  styleUrls: ['./product-list-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListCardComponent extends BaseResizableComponent {
  @Input() product?: LoyaltyProgramListProduct;
  @Input() collectionId?: string;
  @Input() ref?: string;
  @Input() loading = false;
  @Input() showIsFavorite = false;

  /** Признак использования unionId в запросах */
  private useUnionId = false;

  private readonly organisationService = inject(OrganisationService);

  /** ID ассоциации внешней базы */
  get externalUnionId(): string | undefined {
    return this.useUnionId ? this.product?.unionId : undefined;
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.organisationService.currentParentOrganisation$.subscribe(() => {
      this.setUseUnionId();
    });
  }

  /** Заполняем признак использования unionId */
  setUseUnionId() {
    this.useUnionId = this.product?.unionId
      ? this.organisationService.currentParentOrganisation$.value?.id !== this.product.unionId
      : false;
  }
}
